export enum SUFIXO_FIELD {
    LIKE = "_like",
    NOT_LIKE = "_not_like",
    MORE = "_more",
    MORE_EQUAL = "_more_equal",
    LESS = "_less",
    LESS_EQUAL = "_less_equal",
    IS_NULL = "_is_null",
    IS_NOT_NULL = "_is_not_null",
    IN = "_in",
    NOT_IN = "_not_in",
    NOT_EQUAL = "_not_equal",
}

export interface OrFieldSearch {
    field: string;
    criteria: "" | SUFIXO_FIELD.LIKE;
    isNumber?: boolean;
    isDefaultSearch?: boolean;
    label?: string;
}

export interface Filter {
    field: string;
    value: any;
    criteria?: SUFIXO_FIELD;
    isDefaultSearch?: boolean;
    orField?: OrFieldSearch[];
    isNumber?: boolean;
    label?: string;
    arrayField?: string;
    autoCompleteValue?: any;
}

class FilterUtil {

    static build(filterList: Filter[]): string {
        let filter = "";
        if (filterList.length <= 0) {
            return filter;
        }

        for (let _filter of filterList) {
            let value: string = "";
            if (_filter?.criteria !== SUFIXO_FIELD.IS_NULL && _filter?.criteria !== SUFIXO_FIELD.IS_NOT_NULL && (_filter.value === "" || _filter.value === null)) {
                continue;
            }

            // Controla se for IS NULL ou IS NOT NULL, ele não considera o vazio como válido
            if (_filter?.criteria && [SUFIXO_FIELD.IS_NULL, SUFIXO_FIELD.IS_NOT_NULL].includes(_filter?.criteria) && (_filter.value === "")) {
                continue;
            }

            switch (typeof _filter.value) {
                case "string":
                case "number":
                    value = _filter.value.toString();
                    break;
                case "boolean":
                    value = _filter.value === true ? "s" : "n";
                    break;
                case "object":
                    if (Array.isArray(_filter.value)) {
                        value = _filter.value.join(",");
                        break;
                    }
                    if (Object.keys(_filter.value).length > 0 && _filter?.arrayField !== "") {
                        value = _filter.value[String(_filter.arrayField)]
                        break;
                    }
                    break;
                default:
                    break;
            }

            value = String(value).trim();

            if (_filter.isDefaultSearch) {
                const defaultSearchFields = [_filter, ...(_filter?.orField || [])];

                const filters = [];

                const valueIsNumber = value.replace(/\D/g, "") !== "";

                for (let f of defaultSearchFields) {
                    if (f.isNumber && !valueIsNumber) {
                        continue;
                    }
                    filters.push(`${f.field}${f?.criteria || ""}`);
                }

                const mountedField = filters.join("_or_");

                value = filters.length === 1 && !valueIsNumber ? `%${value}%` : value

                filter = `${filter}&${mountedField}=${encodeURIComponent(value)}`;
            } else {
                switch (_filter.criteria) {
                    case undefined:
                        filter = `${filter}&${_filter.field}=${encodeURIComponent(value)}`;
                        break;
                    case SUFIXO_FIELD.IN:
                    case SUFIXO_FIELD.NOT_IN:
                        filter = `${filter}&${_filter.field}${_filter.criteria}=${encodeURIComponent(value)}`;
                        break;
                    case SUFIXO_FIELD.LIKE:
                        filter = `${filter}&${_filter.field}${_filter.criteria}=${encodeURIComponent("%" + value.replace(/\s/g, "%") + "%")}`;
                        break;
                    case SUFIXO_FIELD.IS_NULL:
                    case SUFIXO_FIELD.NOT_LIKE:
                    case SUFIXO_FIELD.IS_NOT_NULL:
                    case SUFIXO_FIELD.MORE:
                    case SUFIXO_FIELD.MORE_EQUAL:
                    case SUFIXO_FIELD.LESS:
                    case SUFIXO_FIELD.LESS_EQUAL:
                        filter = `${filter}&${_filter.field}${_filter.criteria}=${encodeURIComponent(value)}`;
                        break;
                    default:
                        filter = `${filter}&${_filter.field}=${encodeURIComponent(value)}`;
                        break;
                }
            }
        }

        return filter;
    }


}

export { FilterUtil }